import { HTTPError } from '../../error';

export enum ProductType {
  Free = 'free',
  Enterprise = 'enterprise',
  Personal = 'personal',
  Pro = 'pro',
  Distribution = 'distribution',
}

export const stringToProductType = (productType?: string) => {
  const product = productType as ProductType;
  if (!product) {
    throw HTTPError.typeError('Could not parse product to ProductType');
  }
  return product;
};

export default ProductType;
